/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Engagement_Search_WordsInputs */



/**
* | output |
* | --- |
* | "messages, voice, reactions, replies, screen share, content" |
*
* @param {View_Engagement_Search_WordsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const view_engagement_search_words = /** @type {((inputs?: View_Engagement_Search_WordsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Engagement_Search_WordsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("сообщения, голос, реакции, ответы, демонстрация экрана, контент")
	return /** @type {LocalizedString} */ ("messages, voice, reactions, replies, screen share, content")
});